import { validateCPF } from "@/utils/validateCPF";
import * as Yup from "yup";

export const CorbanFormValidationSchema = (
  hasPromoter: boolean = false,
  isNew: boolean = true
) =>
  Yup.object().shape({
    businessName: Yup.string()
      .min(3, "Nome inválido")
      .required("Nome Fantasia é obrigatório"),

    legalName: Yup.string().when([], {
      is: () => !hasPromoter,
      then: (schema) =>
        schema
          .min(3, "Razão social inválida")
          .required("Razão Social é obrigatória"),
      otherwise: (schema) => schema.notRequired(),
    }),

    document: Yup.string().when([], {
      is: () => !hasPromoter,
      then: (schema) =>
        schema.required("CNPJ é obrigatório").min(14, "CNPJ incompleto"),
      otherwise: (schema) => schema.notRequired(),
    }),

    financialSettingsId: Yup.string().when([], {
      is: () => !hasPromoter,
      then: (schema) =>
        schema.required("Configurações Financeiras é obrigatório"),
      otherwise: (schema) => schema.notRequired(),
    }),

    // Dados do Usuário Master (sempre obrigatórios)
    masterUserName: Yup.string()
      .min(3, "Nome inválido")
      .required("Nome do responsável é obrigatório"),

    masterUserLastName: Yup.string()
      .min(3, "Sobrenome inválido")
      .required("Sobrenome do responsável é obrigatório"),

    masterUserCpf: Yup.string()
      .required("CPF é obrigatório")
      .min(11, "CPF incompleto")
      .test("valid-cpf", "CPF inválido", (value) =>
        validateCPF(value || "")
      ),

    masterUserEmail: Yup.string()
      .email("Email inválido")
      .required("Email é obrigatório"),

    masterUserPhone: Yup.string()
      .matches(/\(\d{2}\)\s\d{4,5}-\d{4}/, "Telefone inválido")
      .required("Telefone é obrigatório"),

    masterUserPassword: Yup.string()
      .min(6, "A senha deve ter no mínimo 6 caracteres")
      .test(
        "conditional-required",
        "Senha é obrigatória",
        (value) => !(isNew && !value)
      ),

    masterUserRole: Yup.array()
      .min(1, "Pelo menos um papel deve ser selecionado")
      .required("Papel do usuário é obrigatório"),

    consigWebhookUrl: Yup.string().test(
      'consig-webhook-required',
      'URL Callback/Webhook é obrigatória quando o serviço via API está ativado',
      function (value) {
        const { isConsigApiEnable } = this.parent;
        if (isConsigApiEnable === true) {
          if (!value || value.trim() === '') {
            return false;
          }
          try {
            new URL(value);
            return true;
          } catch {
            return this.createError({ message: 'URL inválida necessário iniciar com https://' });
          }
        }
        return true;
      }
    ),

    fgtsWebhookUrl: Yup.string().test(
      'fgts-webhook-required',
      'URL Callback/Webhook é obrigatória quando o serviço via API está ativado',
      function (value) {
        const { isFGTSApiEnable } = this.parent;
        if (isFGTSApiEnable === true) {
          if (!value || value.trim() === '') {
            return false;
          }
          try {
            new URL(value);
            return true;
          } catch {
            return this.createError({ message: 'URL inválida necessário iniciar com https://' });
          }
        }
        return true;
      }
    ),

    sellerAuthorized: Yup.string()
      .nullable()
      .test(
        "valid-cpf-if-provided",
        "CPF inválido",
        function (value) {
          if (!value || value.trim() === "") {
            return true;
          }
          return validateCPF(value);
        }
      )
      .test(
        "min-length-if-provided",
        "CPF incompleto",
        function (value) {
          if (!value || value.trim() === "") {
            return true;
          }
          const cleanedValue = value.replace(/\D/g, "");
          return cleanedValue.length === 11;
        }
      ),
  });
